import "./base/utilities.js";

// Detect JS
import {jsDetect} from './components/js-detection.js';
jsDetect();

import {mobileNavWatch, submenuToggle} from './components/nav-toggle.js';
mobileNavWatch();
submenuToggle();

import {header} from './components/header.js';
header();

import {helloBar} from './components/hello-bar.js';
helloBar();

import {scrollDetection} from './components/scroll-detection.js';
scrollDetection();

import {scrollPagination} from './components/paginationScroll.js';
scrollPagination();

import {search} from "./components/search.js";
search();

import "./components/read-progress-bar.js";
import "./components/number-counter.js";

import "./blocks/page-builder/accordion.js";

// Tabs
import "./libs/spicy-sections.js";

// Newsletter Web Component
import "@evidence-action/web-components/workable-widget.js";

// Animation
import AOS from 'aos';

window.addEventListener('load', (event) => {
    AOS.init({
        once: 'true',
    });
});
